import { Card, Spin } from 'antd';

export default function Loading() {
    return <Card><Spin delay={100} /></Card>;
}
